module.exports = __webpack_public_path__ + "static/media/page_tips_bg_color.89c253aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/lite/page_tips_bg_color.jpg
// module id = 790
// module chunks = 0